import React from 'react';

const Loading = () => {
  return (
    <div className="loading-overlay">
      <div className="loading-container">
        <div className="spinner">
          <div className="spinner-circle"></div>
        </div>
        <h3>Loading...</h3>
        <p>Please wait</p>
      </div>
      
      <style jsx>{`
        .loading-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(26, 26, 46, 0.95);
          backdrop-filter: blur(8px);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
        }
        
        .loading-container {
          text-align: center;
          color: white;
        }
        
        .spinner {
          width: 50px;
          height: 50px;
          margin: 0 auto 20px;
          position: relative;
        }
        
        .spinner-circle {
          width: 100%;
          height: 100%;
          border: 3px solid rgba(231, 76, 60, 0.2);
          border-top-color: #e74c3c;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }
        
        h3 {
          margin: 0 0 8px 0;
          font-size: 18px;
          font-weight: 600;
          color: #e74c3c;
        }
        
        p {
          margin: 0;
          font-size: 14px;
          color: #8892b0;
        }
        
        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </div>
  );
};

export default Loading;